// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"1715969b","2096":"1715969b","8664":"1715969b"}[chunkId] + ".chunk.css";
};